const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOAD_VALIDATION':
      return {
        ...state,
        ...action.validation,
      };
    case 'CLEAR_ENROLLMENT_FORM':
      return initialState;
    default:
      return state;
  }
}
